<div class="alert alert-success text-center" role="alert" *ngIf="success">
    Pré-checkout aprovado, liberado para seguir a portaria de saída, boa viagem!<br/>
    <strong>Pré-checkout válido até {{dataExpiracao}}</strong>
</div>

<div class="pb col text-center">
    <button type="button" class="btn btn-success custom-button" translate="" *ngIf="!success" (click)="preCheckoutAprovado()">
        Reenviar&nbsp;
        <fa-icon class="float-end" [icon]="['fas', 'paper-plane']" size="lg"></fa-icon>
    </button>
</div>